var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"outlined":"","color":_vm.myColor},on:{"click":_vm.change}},[_vm._v(_vm._s(_vm.ingredient.ingredient))])}
var staticRenderFns = []

export { render, staticRenderFns }